import { createElement } from 'react';
import ReactDOM from 'react-dom';



export function popupGallery(index, media) {
    if(galleryPopupId) {
        const id = Date.now();
        window.attsList = {
            gallery: '<div data-type="gallery" data-index="'+index+'" data-dynamic="'+btoa(JSON.stringify(media))+'">'
        };
        popup(window.galleryPopupId);
    }
}
window.popupGallery = popupGallery;

export function popup(id, associated = [], callback=()=>{}) {
    if(window.event?.target) {
        let target = window.event.target;
        if(target.tagName!='A') target = target.closest('a')?target.closest('a'):target;
        window.ctaRef = window.event.target.innerText.toLowerCase().replace(/\s/g,'');
        if(target.dataset?.atts) {
            window.attsList = JSON.parse(atob(target.dataset.atts));
        }
    }
    if(typeof associated !== 'string') associated = associated.join(',');
    const overlay = document.createElement('div');
    overlay.className="popup-container";
    const loading = document.createElement('div');
    loading.className="popup-loading";
    loading.innerHTML = '<svg viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>';
    const content = document.createElement('div');
    content.className="popup-content";
    overlay.appendChild(loading);
    document.body.appendChild(overlay);
    overlay.onclick = (e) => {
        //overlay.classList.add('closing');
        setTimeout(()=>{ overlay.remove() },parseFloat(window.getComputedStyle(overlay).animationDuration)*1000);
    }
    content.onclick = (e) => { e.stopPropagation(); }
    fetch('/wp-json/smarttouch/popup/'+id+(associated?'/'+associated:'')).then(r=>r.json()).then((p) => {
        loading.classList.add('loaded');
        content.classList.add('popup-'+p.post_name);
        if(p.atts&&Object.keys(p.atts).length) {
            window.attsList = p.atts;
        } else {
            if(window.attsList) p.atts = window.attsList;
        }
        for (const [key, att] of Object.entries(p.atts)) p.post_content = p.post_content.replaceAll('[['+key+']]', att);
        p.post_content = p.post_content.replaceAll(/http\:\/\/http/g,'http');
        p.post_content = p.post_content.replaceAll(/\[\[.*?\]\]/g, '');
        p.post_content = p.post_content.replaceAll(/<a /g, '<a target="_blank" ');
        content.innerHTML = p.post_content;
        const size = Math.min(window.innerWidth, p.size);
        content.querySelectorAll('[data-type="albums"]').forEach(el=>loadAlbums(el, size));
        content.querySelectorAll('[data-type="tours"]').forEach(el=>loadTours(el, size));
        content.querySelectorAll('[data-type="photo"]').forEach(el=>loadPhoto(el, size));
        content.querySelectorAll('[data-type="gallery"]').forEach(el=>loadGallery(el, size));
        content.style.width = p.size + 'px';
        processBlocks(content);
        callback(content);
        overlay.appendChild(content);
        content.querySelectorAll('.wp-block-smarttouch-popup > h2').forEach(h2=>{
            h2.onclick = (e) => {
                overlay.classList.add('closing');
                if(!document.querySelector('.popup-container:not(.closing)')) delete window.attsList;
                setTimeout(()=>{ overlay.remove() },parseFloat(window.getComputedStyle(overlay).animationDuration)*1000);
            }
        });
    });
    const loadPhoto = (el) => {
        const data = JSON.parse(atob(el.dataset.dynamic));
        el.removeAttribute('data-dynamic');
        const content = <img src={data.url} />
        ReactDOM.render(content, el);
    }
    const loadGallery = (el) => {
        const data = JSON.parse(atob(el.dataset.dynamic));
        const index = el.dataset.index||0;
        el.removeAttribute('data-dynamic');
        const id = Date.now();
        const content = <div id={"gallery_"+id} className="swiper">
            <div className="swiper-wrapper">
                {data.map((photo,index)=>{
                    return  <div className="swiper-slide"><img className="swiper-lazy" src={index==0?photo.url:'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='} data-src={photo.url} /> </div>
                })}
            </div>
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
        </div>
        ReactDOM.render(content, el, ()=>{
            const mainEl = el.querySelector('#gallery_'+id);
            const gallery = new Swiper(mainEl, {
                loop: true,
                initialSlide: index,
                preloadImages: false,
                lazy: { loadPrevNext: true },
                navigation: {
                    nextEl: mainEl.querySelector('.swiper-button-next'),
                    prevEl: mainEl.querySelector('.swiper-button-prev'),
                },
                on: {
                    init: (swiper) => { swiper.slideToLoop(index, 0); }
                }
            });
        });
    }
    const loadAlbums = (el, size = 1140) => {
        const data = JSON.parse(atob(el.dataset.dynamic));
        const id = Date.now();
        let albums = false;
        const popup = el.closest('.popup-content');
        const content = <div className="albums">
            <div id={"main_"+id} className="swiper albums-main">
                <div className="swiper-button swiper-button-prev"></div>
                <div className="swiper-button swiper-button-next"></div>
                <div className="swiper-wrapper">
                    {data.map((album,index)=>{
                    return <div className="swiper-slide">
                        <div className="caption">Album {index+1} <span>{album.name}</span></div>
                        <div id={"main_"+id+"_album_"+index} className="album swiper">
                            <div className="swiper-wrapper">
                                {album.photos.map((photo,index)=>{
                                    photo.url = window.themefolder+'image.php?w='+size+'&h=1280&src='+encodeURIComponent(photo.url);
                                    return  <div className="swiper-slide"><img className="swiper-lazy" src={index==0?photo.url:'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='} data-src={photo.url} /> </div>
                                })}
                            </div>
                            <div className="swiper-button-prev"></div>
                            <div className="swiper-button-next"></div>
                        </div>
                    </div>
                    })}
                </div>
            </div>
            <div id={"nav_"+id} className="swiper albums-nav">
                <div className="swiper-wrapper">
                    {data.map(album=>{
                    return <div className="swiper-slide"><img src={album.thumbnail} /><div className="caption">{album.name}</div></div>
                    })}
                </div>
            </div>
        </div>
        el.removeAttribute('data-dynamic');
        ReactDOM.render(content, el,()=>{
            const mainEl = el.querySelector('#main_'+id);
            const main = new Swiper(mainEl, {
                preloadImages: false,
                allowTouchMove: false
            });
            let initialSlide = 0;
            el.querySelectorAll('.album.swiper').forEach((a,index)=>{
                const album = new Swiper(a, {
                    loop: false,
                    preloadImages: false,
                    lazy: { loadPrevNext: true },
                    navigation: {
                        nextEl: a.querySelector('.swiper-button-next'),
                        prevEl: a.querySelector('.swiper-button-prev'),
                    }
                });
            });
            const navEl = el.querySelector('#nav_'+id);
            const nav = new Swiper(navEl, {
                loop: false,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 11,
                effect: "coverflow",
                slideToClickedSlide: true,
                coverflowEffect: {
                rotate: 15,
                stretch: 10,
                depth: 200,
                modifier: 1,
                slideShadows: true,
                },
                navigation: {
                nextEl: mainEl.querySelector('.swiper-button-next'),
                prevEl: mainEl.querySelector('.swiper-button-prev'),
                },
                preloadImages: false,
                lazy: { loadPrevNext: true },
                on: {
                    /*afterInit: (s)=>{
                        initialSlide = s.activeIndex;
                        main.slideTo(0);
                    },
                    slideChangeTransitionEnd: (s)=>{
                        if(s.realIndex==0) s.slideTo(initialSlide,0);
                    },*/
                    slideChange: (s)=>{
                        main.slideTo(s.realIndex);
                    }
                }
            });

        });
    }

    const loadTours = (el) => {
        const data = JSON.parse(atob(el.dataset.dynamic));
        const id = Date.now();
        const content = <div className="tours">
            <div id={"main_"+id} className="swiper tiyrs-main">
                <div className="swiper-wrapper">
                    {data.map((tour,index)=>{
                    return <div className="swiper-slide">
                        <div className="caption">Virtual Tour {index+1} <span>{tour.label}</span></div>
                        <iframe src={tour.url} />
                    </div>
                    })}
                </div>
                <div className="swiper-button swiper-button-prev"></div>
                <div className="swiper-button swiper-button-next"></div>
            </div>
        </div>
        el.removeAttribute('data-dynamic');
        ReactDOM.render(content, el,()=>{
            const mainEl = el.querySelector('#main_'+id);
            const main = new Swiper(mainEl, {
                loop: false,
                navigation: {
                    nextEl: mainEl.querySelector('.swiper-button-next'),
                    prevEl: mainEl.querySelector('.swiper-button-prev'),
                }
            });
        });
    }
}
window.popup = popup;